// @ts-nocheck
export default (pxValue: string | null) => {
    const pxRegex = /px/i;

    if (pxValue === null) {
        return null;
    }

    return Number(pxValue?.replace(pxRegex, ""));
};
